import { DOCUMENT } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';

import { CheckoutStorageService, Oauth2Service, UserService } from '@bytel/checkout';

import { ModalService } from '@base/common/services/modal.service';

import { ConfigurationService } from '@services/configuration.service';

import { ModalComponent } from '@shared/modal/modal.component';

import { Subscription } from 'rxjs';

// @dynamic
@Component({
    selector: 'checkout-customer-error-modal',
    templateUrl: './customer-error-modal.component.html',
    styleUrl: 'customer-error-modal.component.scss',
    imports: [ModalComponent],
    standalone: true,
})
export class CustomerErrorModalComponent extends ModalComponent {
    public static readonly cannotBeOverriden: boolean = true;

    title: string = 'Oups !';
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_erreur_client_connexion',
        categorieClic: 'Modale_erreur_client_connexion',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Terminer',
        categorieClic: 'Modale_erreur_client_connexion',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_erreur_client_connexion',
    };

    public modalRef: ModalService;
    public afterClosedSubscription: Subscription;
    private configurationService = inject(ConfigurationService);
    private oauth2Service = inject(Oauth2Service);
    private checkoutStorage = inject(CheckoutStorageService);

    constructor(@Inject(DOCUMENT) private document: Document) {
        super();
    }

    public ngOnInit(): void {
        this.afterClosedSubscription = this.modalRef.afterClosed.subscribe(() => {
            this.onCloseHandler();
        });
    }

    public ngOnDestroy(): void {
        this.afterClosedSubscription.unsubscribe();
    }

    public logout(): void {
        this.oauth2Service.logout();
        const domain: string = this.configurationService.getData()?.global.origin;
        this.document.defaultView.location.href = `${
            this.configurationService.getData()?.oauth?.logoutUrl
        }?service=${domain}${UserService.SIGNUP_PATH}`;
    }

    private onCloseHandler(): void {
        this.checkoutStorage.clear();
        this.document.defaultView.location.href = this.configurationService.getData()?.global.origin;
    }
}
